import React from 'react'

import { Box, Button, List, Title } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import WithPaywall from 'modules/finance/components/WithPaywall'

import DimensionList from './DimensionList'
import NewDimensionModal from './NewDimensionModal'

interface Props {}

const DimensionsSettings = ({}: Props) => {
  const [showNewDimensionModal, setShowNewDimensionModal] = React.useState(false)

  const handleAddDimension = () => {
    track(trackingEvents.accounting.dimensionsAddStart)
    setShowNewDimensionModal(true)
  }

  return (
    <Box flexDirection="row" width="full" justifyContent="spaceBetween" paddingTop="s12" gap="s64">
      <Box flexDirection="column" gap="s32">
        <Title
          variant="400"
          title={i18n.t('finance.settings.dimensions.title')}
          description={i18n.t('finance.settings.dimensions.description')}
          illustration="report-library"
        />
        <Box maxWidth="s360">
          <WithPaywall features={[Features.finance_custom_dimensions]} fallback={<></>}>
            {() => (
              <Button type="secondary" onClick={handleAddDimension} iconName="add">
                {i18n.t('finance.settings.dimensions.add_dimension')}
              </Button>
            )}
          </WithPaywall>
        </Box>
      </Box>
      <Box minWidth="s300">
        <List>
          <WithPaywall features={[Features.finance_custom_dimensions]} fallback={<></>}>
            {() => <DimensionList />}
          </WithPaywall>
        </List>
      </Box>
      {showNewDimensionModal && (
        <NewDimensionModal onClose={() => setShowNewDimensionModal(false)} />
      )}
    </Box>
  )
}

export default DimensionsSettings
